import React, { useRef } from "react";
import "./HomeHeader.css";
import { useNavigate } from "react-router-dom";

const HomeHeader = ({ searchQuery, onSearchChange, activeTab, handleTabChange }) => {
  const searchTimeout = useRef(null);
  const navigate = useNavigate();

  const handleSearchChange = (e) => {
    const value = e.target.value;

    clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      onSearchChange(value.trim());
    }, 200);
  };

  return (
    <header className="home-header">
      <div className="home-header-inner">
        {/* 🔹 Left: Logo */}
        <div className="home-header-left" onClick={() => navigate("/")}>
          <img src="/images/scoldy-header-icon.png" alt="Scoldy Logo" />
        </div>

        {/* 🔹 Center: Tabs */}
        <div className="home-header-center">
          <span
            className={`pings-text ${activeTab === "forYou" ? "active-tab" : ""}`}
            onClick={() => handleTabChange("forYou")}
          >
            For you
          </span>
          <span
            className={`following-text ${activeTab === "following" ? "active-tab" : ""}`}
            onClick={() => handleTabChange("following")}
          >
            Following
          </span>
        </div>

        {/* 🔹 Right: Search and balancing logo */}
        <div className="home-header-right">
          <input
            type="text"
            className="home-search-box"
            placeholder="Search posts or @user..."
            value={searchQuery}
            onChange={handleSearchChange}
          />

          <div className="home-header-right-logo" onClick={() => navigate("/")}>
            <img src="/images/scoldy-header-icon.png" alt="Scoldy Logo" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default HomeHeader;
